<template>
  <div v-if="loaded">
    <div class="table_sec">
      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="section_title">
            <h2>Industry Financials</h2>
          </div>
          <div>
            <h3 class="sub_header">Income Statement</h3>
          </div>
          <div class="table-box">
            <div class="tbl-title">
              <h4>Percentages</h4>
            </div>
            <div class="inner-tbl">
              <md-table v-model="tableDataPercent" table-header-color="blue" class="dark_blue" style="flex: 1;">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell :class="item.name === 'Cost of Sales - Labor Portion'
                    ? 'md-table-side-label pl-2'
                    : 'md-table-side-label'">
                    {{ item.name }}
                    <md-tooltip md-direction="bottom">
                      {{
                        item.rollover
                      }}
                    </md-tooltip>
                  </md-table-cell>


                  <!-- <md-table-cell md-label="Trend" class="table_chart">
                  <chart-card
                    header-animation="false"
                    :chart-data="
                      newChartPercentOptions[item.name].data
                    "
                    :chart-options="
                      chartOptions
                    "
                    chart-type="Line"
                    header-icon
                    chart-inside-content
                    no-footer
                    background-color="blue"
                  ></chart-card>
                </md-table-cell> -->

                  <md-table-cell v-for="key in Object.keys(
                        item.dates
                      )" :key="key" :md-label="key">
                    {{
                      item.dates[key]
                    }}%
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </div>
          <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
        </div>
      </div>


      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="table-box">
            <div class="tbl-title">
              <h4>Dollars ( All figures in USD )</h4>
            </div>
            <div class="inner-tbl">
              <md-table v-model="tableDataDollar" table-header-color="blue" class="dark_blue" style="flex: 1;">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell :class="item.name === 'Cost of Sales - Labor Portion'
                    ? 'md-table-side-label pl-2'
                    : 'md-table-side-label'">
                    {{ item.name }}
                    <md-tooltip md-direction="bottom">
                      {{
                        item.rollover
                      }}
                    </md-tooltip>
                  </md-table-cell>

                  <!-- <md-table-cell md-label="Trend" class="table_chart">
                  <chart-card
                    header-animation="false"
                    :chart-data="
                      newChartDollarOptions[item.name].data
                    "
                    :chart-options="
                      chartOptions
                    "
                    chart-type="Line"
                    header-icon
                    chart-inside-content
                    no-footer
                    background-color="blue"
                  ></chart-card>
                </md-table-cell> -->

                  <md-table-cell v-for="key in Object.keys(
                        item.dates
                      )" :key="key" :md-label="key">
                    ${{
                      item.dates[key]
                    }}
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </div>
          <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
        </div>
      </div>

      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
          <div class="table-box">
            <div class="tbl-title">
              <h4>Charts ( All figures in USD )</h4>
            </div>
            <div class="inner-tbl">
              <div class="md-layout px-4 mb-4">
                <div v-for="(chart, i) in charts" :key="i" class="md-layout-item md-medium-size-100 md-size-50">
                  <chart-card header-animation="false" :chart-data="chart.data" :chart-options="getOptions(chart.options)
                    " chart-type="Pie" header-icon chart-inside-content background-color="blue">
                    <template slot="chartInsideHeader">
                      <h4 class="title m-0">
                        <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">{{ chart.title }}</div>
                      </h4>
                    </template>
                    <template slot="footer">
                      <div class="md-layout">
                        <div class="md-layout-item">
                          <span v-for="(v, i) in chart
                                .options.legendNames" :key="i" :class="`ct-series-${i}`">
                            <i class="fa fa-circle"></i>
                            {{ v }} ({{
                              chart.options.labelInterpolationSignFn(
                                chart.data.series[i]
                              )
                            }})
                          </span>
                        </div>
                        <div style="padding-top: 35px;" class="md-layout-item md-size-100">
                          <p class="common_footer black-color">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                        </div>
                      </div>
                    </template>
                  </chart-card>
                </div>
              </div>
            </div>
          </div>
          <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
export default {
  components: {
    ChartCard,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      loaded: false,
      view: 'dollar',
      options: {
        donut: true,
        showLabel: false,
        legendNames: [],
        labelInterpolationFnc: (value) => value + '$',
        height: '150px',
        width: '150px',
      },
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      newChartDollarOptions: [],
      newChartPercentOptions: [],
      charts: [],
      tableDataDollar: [],
      tableDataPercent: [],
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: '',
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      spif: (state) => state.user.profile.spif,
      chartData: (state) => state.user.profile.chartData ? state.user.profile.chartData['profitLoss'] : null,
      table: (state) => state.user.profile.tables ? state.user.profile.tables['PL'] : null,
      rolloverAux: (state) => state.user.profile.data ? state.user.profile.data[0].array_BB.array_lookup_ALL : null,
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      BStable: (state) => state.user.profile.tables ? state.user.profile.tables['BS'] : null,
      tables: (state) => state.user.profile.tables ? state.user.profile.tables['ratios'] : null,
      tablesInfo: (state) => state.user.profile.tables ? state.user.profile.tables['ratioInfo'] : null,
      sourcesUses: (state) => state.user.profile ? state.user.profile['sourcesUses'] : null,
      sourceYears: (state) => state.user.profile.sourcesUsers ? state.user.profile['sourcesUses']['years'] : null,
      release_display: (state) => state.user.profile.release_display,
      bznaics_code: (state) => state.user.profile.bznaics,
      sector_name: (state) => state.user.profile.data ? state.user.profile.data[0].sector : null,
      industry_title: (state) => state.user.profile.data ? state.user.profile.data[0].industry : null,
      sales_class: (state) => state.user.profile.data ? state.user.profile.data[0].sales_class : null,
      display_area: (state) => state.user.profile.data ? state.user.profile.data[0].display_area : null,
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },

    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    sourceYears(newVal, oldVal) {
      if (this.sourceTablesInfo && newVal) {
        Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
          this.$set(this, table, this.formatSourcesData(table, data))
        );
      }
    },
    profile(newVal, oldVal) {
      this.init();
    }
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    getOptions(newOptions) {
      return {
        ...this.options,
        ...newOptions,
      };
    },

    labelInterpolation(data) {
      return (value) => {
        return (
          Math.round(
            (value /
              data.reduce(function (a, b) {
                return a + b;
              })) *
            100
          ) + '%'
        );
      };
    },
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];
          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
    init() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'dollar';
      }

      this.switchView(section);

      if (this.profile.data) {
        let firmData = Object.values(this.profile.data)
          .filter((item) => item)
          .map((item) => ({ ...item, firms: item.firms }));

        firmData.forEach((element) => {
          this.filtered_firms.push(parseFloat(element.firms));
        });

      }

      if (this.sales_class && this.sales_class.includes(',')) {
        this.sales_class_csv = this.sales_class.replace(/,/g, '');
      }

      this.charts = this.formatPieChart(this.chartData);
      this.charts = this.charts.filter(function (el) {
        return el.type === 'dollar'
      })

      var rolloverArray = [];
      if (this.rolloverAux)
        Object.entries(this.rolloverAux).forEach(([index, item]) => {
          rolloverArray[item.title] = item.description;
        });

      this.tableDataDollar = this.formatTable(this.table, 'industry', 'dollar', rolloverArray);
      this.tableDataPercent = this.formatTable(this.table, 'industry', 'percent', rolloverArray);

      if (this.profile.years)
        this.profile.years.forEach((e, i) => {
          this.filtered_years.push(Number(e));
        });

      this.tableDataDollar.forEach((element) => {
        let k = Object.values(element.dates);
        if (element.name.includes(',')) {
          element.name = element.name.replace(/,/g, '');
        }
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.name);
        this.filtered_PLDollar.push(v);
      });

      this.tableDataDollar.forEach(element => {

        this.newChartDollarOptions[element.name] = {
          data: {
            labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, ""))]],
            series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, ""))]]
          },
        }
      });



      this.tableDataPercent.forEach((element) => {
        let z = Object.values(element.dates);
        if (element.name.includes(',')) {
          element.name = element.name.replace(/,/g, '');
        }
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === 'string' && item.includes(',')) {
            item = parseFloat(item.replace(/,/g, ''));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercent.push(v);
      });

      this.tableDataPercent.forEach(element => {
        this.newChartPercentOptions[element.name] = {
          data: {
            labels: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, ""))]],
            series: [[...Object.keys(element.dates).map(i => element.dates[i].toString().replace(/,/g, ""))]]
          },
        }
      });


      let BSpercent = this.formatTable(this.BStable, 'industry', 'percent', rolloverArray);
      let BSdollar = this.formatTable(this.BStable, 'industry', 'dollar', rolloverArray);

      BSdollar.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.name);
        this.filtered_BSDollar.push(v);
      });
      BSpercent.forEach((element) => {
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === 'string' && item.includes(',')) {
            item = parseFloat(item.replace(/,/g, ''));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercent.push(v);
      });

      if (!_.isEmpty(this.tables)) {
        Object.entries(this.tables).forEach(
          ([table, data]) => this.$set(this, table, this.formatTable(data, 'industry'))
        );
      }
      let cashFlowData = [];
      this.cashflow.forEach((element, index) => {
        if (element.name in this.tables['cashflow']) {
          cashFlowData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      cashFlowData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.cashFlowFilteredData.push(v);
      });

      let efficiencyData = [];
      this.efficiency.forEach((element, index) => {
        if (element.name in this.tables['efficiency']) {
          efficiencyData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      efficiencyData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.efficiencyFilteredData.push(v);
      });

      let profitabilityData = [];
      this.profitability.forEach((element, index) => {
        if (element.name in this.tables['profitability']) {
          profitabilityData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      profitabilityData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.profitabilityFilteredData.push(v);
      });

      let debtRiskData = [];
      this.turnover.forEach((element, index) => {
        if (element.name in this.tables['turnover']) {
          debtRiskData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      debtRiskData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });

        v.unshift(element.title);
        this.debtRiskFilteredData.push(v);
      });

      if (this.sourceYears & this.sourceTablesInfo)
        Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
          this.$set(this, table, this.formatSourcesData(table, data))
        );

      this.changein.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.changeinFilteredData.push(k);
      });
      this.worksheet.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.worksheetFilteredData.push(k);
      });

      this.loaded = true;
    }

  },
};
</script>

